import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShipToUnitedStatesComponent } from 'src/app/components/seo-booster-pages/ship-to-united-states/ship-to-united-states.component';


const routes: Routes = [
  {
    path: '', component: ShipToUnitedStatesComponent, 
  }

];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BoosterRoutingModule {
  constructor() {


  }
}
